import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $expandable: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	cursor: ${({ $expandable }) => ($expandable ? 'pointer' : 'default')};
	transition:
		background-color 0.3s ease,
		border 0.3s ease;

	&:hover {
		background-color: rgba(255, 255, 255, 0.05);
		border: 1px solid rgba(255, 255, 255, 0.1);
	}
`;

const StyledTopContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledText = styled(Text)<{ $isExpanded: boolean }>`
	font-size: 14px;
	color: rgba(255, 255, 255, 0.75);

	${({ $isExpanded }) =>
		$isExpanded
			? css`
					display: block;
					overflow: visible;
					text-overflow: clip;
			  `
			: css`
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					overflow: hidden;
					text-overflow: ellipsis;
			  `}
`;

const StyledBottomContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledButtonsContainer = styled.div`
	display: flex;
	gap: 10px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	gap: 10px;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledStatusContainer = styled.div<{ $status: 'pending' | 'published' }>`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 30px;
	padding: 0 10px;
	border-radius: 5px;
	transition:
		background-color 0.3s ease,
		border 0.3s ease;

	.dot {
		width: 10px;
		height: 10px;
		border-radius: 10px;
		transition: background-color 0.3s ease;
	}

	${Text} {
		font-weight: 500;
		font-size: 14px;
		transition: color 0.3s ease;
	}

	${({ $status }) =>
		$status === 'pending' &&
		css`
			background-color: rgba(255, 255, 255, 0.02);
			border: 1px solid rgba(255, 255, 255, 0.05);

			.dot {
				background-color: rgba(255, 255, 255, 0.1);
			}

			${Text} {
				color: rgba(255, 255, 255, 0.25);
			}
		`}

	${({ $status }) =>
		$status === 'published' &&
		css`
			background-color: rgba(31, 128, 52, 0.1);
			border: 1px solid rgba(31, 128, 52, 0.5);

			.dot {
				background-color: #1f8034;
			}

			${Text} {
				color: #1f8034;
			}
		`}
`;

const StyledMyAdsButtonsContainer = styled.div`
	display: flex;
	gap: 10px;
`;

const StyledAdsTooltipPortal = styled.div`
	position: fixed;
	z-index: 10000;
	pointer-events: none;
	transform: translateX(-50%);
	opacity: 0;
	transition: opacity 0.25s ease;

	&.popup-enter {
		opacity: 0;
	}

	&.popup-enter-active,
	&.popup-enter-done,
	&.popup-exit {
		opacity: 1;
	}

	&.popup-exit-active {
		opacity: 0;
	}
`;

export {
	StyledAdsTooltipPortal,
	StyledBottomContainer,
	StyledButtonContent,
	StyledButtonsContainer,
	StyledContainer,
	StyledMyAdsButtonsContainer,
	StyledStatusContainer,
	StyledText,
	StyledTopContainer,
};
